export function getStoreProductTitle(product = {}, fallback = "상품") {
  return (
    product.display_name ||
    product.name ||
    product.model_name ||
    `${product.brand || product.brand_name || ""} ${product.model_name || ""}`.trim() ||
    fallback
  );
}

export function getCartProductTitle(item = {}, fallback = "상품") {
  const product = item.product || {};
  return getStoreProductTitle(product, fallback);
}
